export default __webpack_public_path__ + "static/media/119.51b976b2.png";